
import { API_CONFIG } from '../utils/constants';
import { getAuthToken } from '../utils/cookieUtils';


export const updateUserNotificationState = async () => {
    try {
        const token = getAuthToken();
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await fetch(`${API_CONFIG.BASE_URL}/Notification/UpdateUserNotificationState`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Error fetching user details: ${response.status}`);
        }

        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        console.error('Error fetching user details:', error);
        return { success: false, error: error.message };
    }
};
export const checkUserNotificationState = async () => {
    try {
        const token = getAuthToken();
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await fetch(`${API_CONFIG.BASE_URL}/Notification/CheckUserNotificationState`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Error fetching user details: ${response.status}`);
        }

        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        console.error('Error fetching user details:', error);
        return { success: false, error: error.message };
    }
};

const notificationService = {
    updateUserNotificationState,
    checkUserNotificationState
};

export default notificationService;